<template>
  <div class="modal fade" ref="mdlTecnicos" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content" style="border:none">
        <div class="modal-header bg-success">
          <h4 class="modal-title text-white">
            Filtro por tecnicos
          </h4>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p>
            Selecciona los tecnicos para filtrar los tickets de soporte.
          </p>
          <table class="table table-hover align-middle">
            <tbody>
              <tr v-for="tecnico in tecnicos" :key="tecnico.id">
                <td>
                  <div class="form-check form-switch form-switch-right form-switch-md">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'tecnico-' + tecnico.id"
                      @change="seleccionar()"
                      v-model="tecnico.palanca_activo"
                    />
                    <label
                      class="form-check-label"
                      :for="'tecnico-' + tecnico.id"
                    >
                      {{tecnico.nombre ? tecnico.nombre : ''}}
                      {{tecnico.apellido_paterno ? tecnico.apellido_paterno : ''}}
                      {{tecnico.apellido_materno ? tecnico.apellido_materno : ''}}
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioSrv from '@/services/UsuarioSrv.js'
import Modal from 'bootstrap/js/dist/modal';
export default {
  name: 'MdlUsuario',
  data() {
    return {
      ids_tecnicos: [],
      tecnicos: []
    }
  },
  methods: {
    seleccionar() {
      var self = this

      let idsTec = self.tecnicos.filter(usu => {
        if(usu.palanca_activo == true) return usu.id
      })

      idsTec = idsTec.map(id => id.id)

      this.$emit('ids:tecnicos:seleccionado', idsTec)
    },
    mostrar(ids_tecnicos) {
      var self = this
      self.ids_tecnicos = ids_tecnicos
      var modal = new Modal(this.$refs.mdlTecnicos)
      modal.show()
      this.refrescarTecnicos()
    },
    refrescarTecnicos() {
      let self = this, 
          params = { todos: false, solo_tecnicos: true }

      UsuarioSrv.usuariosJSON(params).then(response => {
        var tecnicos = response.data

        tecnicos.forEach(tecnico => {
          let id = self.ids_tecnicos.find(id => {
            return id == tecnico.id
          })
          tecnico.palanca_activo = id ? true : false
        });

        self.tecnicos = tecnicos
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudieron cargar los tecnicos'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
.form-check-input:checked {
  background-color: #63AD6F;
  border-color: #63AD6F;
}
</style>